// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Vector2, IVector2 } from "./System.Numerics.Vector2.gen";

export interface IPolygon {
	points: IVector2[] | undefined;

	isComplete: boolean;

	name: string | undefined;

	$type?: string | undefined;
}
export class Polygon {
	constructor(data?: IPolygon) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.points = data.points ? data.points.map((p: any) => new Vector2(p)) : [];
	}

	points: Vector2[] | undefined = [];

	isComplete: boolean = false;

	name: string | undefined;

	static $type: string = "Shared.Geometry.Polygon, ";
	$type?: string | undefined = Polygon.$type;
}

